import * as React from 'react';
import classNames from 'classnames';
import Icon from '../Icon';
import './Select.scss';

export interface ISelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  elementSize?: 'small' | 'large';
  variant?: 'light';
}

const Select = ({
  className,
  elementSize,
  variant,
  children,
  ...selectProps
}: ISelectProps) => (
  <div
    className={classNames(
      'select',
      className,
      elementSize ? `is-${elementSize}` : 'is-small',
      variant && `is-${variant}`
    )}
  >
    <select {...selectProps}>{children}</select>
    <Icon name="chevron-down" className="select-icon" />
  </div>
);

export default Select;



// WEBPACK FOOTER //
// ./src/components/FormElements/Select.tsx